module.exports = __webpack_public_path__ + "static/media/icon-supplies-cottonpads.66f1c2e1.svg";